import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function HowItWorksPage() {
  const steps = [
    {
      number: '01',
      title: '登録',
      description: '居場所・ボランティアが簡単登録',
      icon: 'ri-user-add-line',
      details: 'シンプルな登録フォームで、必要な情報を入力するだけ。同意事項を確認して安全にスタートできます。'
    },
    {
      number: '02',
      title: 'つながる',
      description: '課題アップロードでマッチング',
      icon: 'ri-upload-cloud-line',
      details: '居場所スタッフが課題や質問をアップロード。ボランティアが支援を申し出て、最適なマッチングが実現します。'
    },
    {
      number: '03',
      title: '続ける',
      description: '最短1分で授業開始、継続をサポート',
      icon: 'ri-play-circle-line',
      details: 'オンラインで即座に授業開始。AIアドバイスや謝金ポイントシステムで、安心して長く続けられます。'
    }
  ];

  const simpleSteps = [
    {
      number: '01',
      title: '課題をアップロード',
      description: '学びたい内容や質問を簡単にアップロード',
      icon: 'ri-upload-cloud-2-line',
      image: 'https://public.readdy.ai/ai/img_res/74e63b9e4d365017f2d93614c06937ae.jpg'
    },
    {
      number: '02',
      title: 'ボランティアとマッチング',
      description: '最適なボランティアが見つかります',
      icon: 'ri-user-heart-line',
      image: 'https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20illustration%20showing%20two%20people%20connecting%20through%20a%20digital%20matching%20system%20with%20heart%20icons%20and%20connection%20lines%20between%20profiles%20representing%20volunteer%20and%20student%20matching%20in%20a%20bright%20simple%20background%20with%20soft%20pastel%20colors%20modern%20flat%20design%20style%20educational%20connection%20concept&width=400&height=300&seq=howitworks02&orientation=landscape'
    },
    {
      number: '03',
      title: '授業開始',
      description: 'オンラインですぐに学習スタート',
      icon: 'ri-video-chat-line',
      image: 'https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20illustration%20showing%20an%20online%20learning%20session%20with%20a%20student%20and%20teacher%20on%20video%20call%20screen%20with%20educational%20materials%20and%20books%20around%20them%20in%20a%20bright%20simple%20background%20with%20soft%20pastel%20colors%20modern%20flat%20design%20style%20online%20education%20concept&width=400&height=300&seq=howitworks03&orientation=landscape'
    }
  ];

  const subjects = [
    { name: '国語', icon: 'ri-book-open-line', color: 'from-pink-500 to-rose-500' },
    { name: '数学', icon: 'ri-calculator-line', color: 'from-blue-500 to-cyan-500' },
    { name: '英語', icon: 'ri-global-line', color: 'from-purple-500 to-indigo-500' },
    { name: '理科', icon: 'ri-flask-line', color: 'from-green-500 to-emerald-500' },
    { name: '社会', icon: 'ri-earth-line', color: 'from-orange-500 to-amber-500' }
  ];

  const features = [
    {
      title: '柔軟な参加スタイル',
      description: '1対1のオンライン、みんなでオンライン、1つの画面をみんなで見る形式など、多様な学習スタイルに対応',
      icon: 'ri-group-line',
      color: 'from-blue-500 to-teal-500'
    },
    {
      title: 'AIの事前アドバイス',
      description: 'アップされた課題や質問をAIが解析して、指導アドバイスを作成。ボランティアが安心して参加できる',
      icon: 'ri-robot-line',
      color: 'from-purple-500 to-blue-500'
    },
    {
      title: '謝金の支払いがラク',
      description: '謝金ポイントは必要な分だけ事前購入。使いすぎの心配なし。授業が終わったらボランティアにポイントが渡される',
      icon: 'ri-coin-line',
      color: 'from-green-500 to-teal-500'
    }
  ];

  const costBreakdown = [
    { emoji: '🧑‍🏫', category: 'ボランティアへの謝金', percentage: 62.5, description: '謝金', color: '#14B8A6' },
    { emoji: '💴', category: '源泉所得税', percentage: 6.3, description: 'サービス側で預かり→国へ納付', color: '#3B82F6' },
    { emoji: '🧾', category: '消費税（サービス側納付）', percentage: 9.2, description: '講師免税のため控除不可、全額サービス負担', color: '#8B5CF6' },
    { emoji: '💳', category: '決済手数料（Stripe等）', percentage: 3.7, description: '決済代行会社へ支払い', color: '#F59E0B' },
    { emoji: '🧠', category: 'サーバー維持費', percentage: 4.0, description: 'クラウド・通信費など', color: '#EF4444' },
    { emoji: '🤖', category: 'AI利用料', percentage: 4.0, description: 'ChatGPT・音声解析等の利用費', color: '#10B981' },
    { emoji: '🧩', category: '運営維持費', percentage: 3.0, description: '管理・人件費等の一般管理費', color: '#6366F1' },
    { emoji: '💻', category: 'ソフト使用料', percentage: 3.0, description: 'ライセンス・システム費用', color: '#F97316' },
    { emoji: '🏛️', category: 'その他税金・予備費', percentage: 4.3, description: '事業税・法人税など将来分含む', color: '#84CC16' }
  ];

  // 円グラフ用のSVGパス計算
  const createPieChart = () => {
    let cumulativePercentage = 0;
    const radius = 80;
    const centerX = 100;
    const centerY = 100;

    return costBreakdown.map((item, index) => {
      const startAngle = (cumulativePercentage / 100) * 360 - 90; // -90度で12時位置から開始
      const endAngle = ((cumulativePercentage + item.percentage) / 100) * 360 - 90;
      
      const startAngleRad = startAngle * (Math.PI / 180);
      const endAngleRad = endAngle * (Math.PI / 180);
      
      const x1 = centerX + radius * Math.cos(startAngleRad);
      const y1 = centerY + radius * Math.sin(startAngleRad);
      const x2 = centerX + radius * Math.cos(endAngleRad);
      const y2 = centerY + radius * Math.sin(endAngleRad);
      
      const largeArcFlag = item.percentage > 50 ? 1 : 0;
      
      const pathData = [
        `M ${centerX} ${centerY}`,
        `L ${x1} ${y1}`,
        `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`,
        'Z'
      ].join(' ');

      cumulativePercentage += item.percentage;

      return {
        ...item,
        pathData,
        startAngle,
        endAngle
      };
    });
  };

  const pieChartData = createPieChart();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            ボラタスのしくみ
          </h1>
          <p className="text-lg text-gray-600 mb-4">
            3つのステップで、居場所とボランティアをやさしくつなぎます
          </p>
          <p className="text-base text-teal-700 font-medium">
            支援者の手間を減らし、こどもに向き合う時間を増やす。それがボラタスの目指す形です。
          </p>
          <div className="w-24 h-1 bg-teal-500 mx-auto mt-8"></div>
        </div>
      </section>

      {/* Simple Steps Section with Images */}
      <section className="py-16 px-4 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {simpleSteps.map((step, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="relative mb-6">
                  <div className="w-full h-48 rounded-xl overflow-hidden mb-4">
                    <img 
                      src={step.image} 
                      alt={step.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute -top-3 -left-3 w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center text-lg font-bold shadow-lg">
                    {step.number}
                  </div>
                </div>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-blue-500 rounded-lg flex items-center justify-center">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>

          {/* Catchphrase */}
          <div className="text-center bg-white rounded-2xl p-8 shadow-sm border-2 border-teal-500">
            <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              ボラタスがあれば、<br className="md:hidden" />
              <span className="text-teal-600">国語も数学も英語も全部学べる！</span>
            </p>
            <div className="flex flex-wrap justify-center gap-3 mt-6">
              {subjects.map((subject, index) => (
                <div key={index} className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-full">
                  <div className={`w-8 h-8 bg-gradient-to-br ${subject.color} rounded-full flex items-center justify-center`}>
                    <i className={`${subject.icon} text-sm text-white`}></i>
                  </div>
                  <span className="text-sm font-semibold text-gray-700">{subject.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* YouTube Video Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
            学習セッションの方法紹介
          </h2>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl shadow-lg"
              src="https://www.youtube.com/embed/kqu9jQdcZv4"
              title="学習セッションの方法紹介"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      {/* Steps Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-8">
                  <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-teal-600 font-semibold mb-4">{step.description}</p>
                <p className="text-gray-600 leading-relaxed">{step.details}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cost Breakdown Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4">
            居場所からの費用の使い道
          </h2>
          <p className="text-center text-gray-600 mb-12">
            透明性を重視し、費用の内訳を詳しくご説明します
          </p>
          
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* 円グラフ */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">費用配分</h3>
              <div className="flex justify-center mb-6">
                <svg width="200" height="200" viewBox="0 0 200 200">
                  {pieChartData.map((item, index) => (
                    <path
                      key={index}
                      d={item.pathData}
                      fill={item.color}
                      stroke="white"
                      strokeWidth="1"
                      className="hover:opacity-80 transition-opacity cursor-pointer"
                    />
                  ))}
                </svg>
              </div>
              
              {/* 凡例 */}
              <div className="grid grid-cols-1 gap-2">
                {costBreakdown.map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div 
                      className="w-4 h-4 rounded-sm flex-shrink-0"
                      style={{ backgroundColor: item.color }}
                    ></div>
                    <span className="text-sm text-gray-700 flex-1">
                      {item.emoji} {item.category}
                    </span>
                    <span className="text-sm font-semibold text-gray-900">
                      {item.percentage}%
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* 詳細表 */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-6">詳細内訳</h3>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-gray-200">
                      <th className="text-left py-3 px-2 text-sm font-semibold text-gray-700">区分</th>
                      <th className="text-center py-3 px-2 text-sm font-semibold text-gray-700">割合</th>
                      <th className="text-left py-3 px-2 text-sm font-semibold text-gray-700">内容</th>
                    </tr>
                  </thead>
                  <tbody>
                    {costBreakdown.map((item, index) => (
                      <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="py-3 px-2">
                          <div className="flex items-center gap-2">
                            <span className="text-lg">{item.emoji}</span>
                            <span className="text-sm text-gray-900 font-medium">{item.category}</span>
                          </div>
                        </td>
                        <td className="py-3 px-2 text-center">
                          <span className="text-sm font-semibold text-gray-900">{item.percentage}%</span>
                        </td>
                        <td className="py-3 px-2">
                          <span className="text-sm text-gray-600">{item.description}</span>
                        </td>
                      </tr>
                    ))}
                    <tr className="border-t-2 border-gray-300 font-semibold">
                      <td className="py-3 px-2 text-sm text-gray-900">合計</td>
                      <td className="py-3 px-2 text-center text-sm text-gray-900">100%</td>
                      <td className="py-3 px-2 text-sm text-gray-600">—</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* 補足説明 */}
          <div className="mt-8 bg-blue-50 rounded-xl p-6 border border-blue-200">
            <div className="flex items-start gap-3">
              <i className="ri-information-line text-xl text-blue-600 mt-1"></i>
              <div>
                <h4 className="font-semibold text-blue-900 mb-2">費用の透明性について</h4>
                <p className="text-blue-800 text-sm leading-relaxed mb-2">
                  ボラタスでは、居場所の皆さまからお預かりした費用の使い道を明確にし、
                  ボランティアの方々への適切な謝金支払いと、サービスの継続的な改善に努めています。
                  最大の割合（62.5%）がボランティアの方々への謝金として直接還元されます。
                </p>
                <p className="text-teal-700 text-sm leading-relaxed font-medium">
                  支援者が適切に報われることで、支援の質と継続性が保たれ、結果的にこどもたちの学びにつながります。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
            続けやすい　3つの仕組み
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-full flex items-center justify-center mx-auto mb-6`}>
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed text-center">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-customer-service-2-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">いつでもサポート</h3>
                <p className="text-gray-600 mb-4">
                  サービス内の報告フォームでいつでも管理者に連絡可能。困ったことがあれば、すぐに相談できます。
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm">安全第一</span>
                  <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm">迅速対応</span>
                  <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">継続サポート</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
            今すぐ始めませんか？
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://boratasu.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              サービスを使ってみる
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
